var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongSuoKai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.556 9a.5.5 0 00-1 0h1zm-1 2a.5.5 0 001 0h-1zm0-2v2h1V9h-1z",
    fill: "#3F465C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    width: 9.625,
    height: 7,
    rx: 0.5,
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5c-1.372 0-2.5 1.135-2.5 2.556V6.5a.5.5 0 01-1 0V5.056C4.5 3.1 6.058 1.5 8 1.5c1.723 0 3.145 1.262 3.443 2.911a.5.5 0 01-.984.178C10.243 3.394 9.218 2.5 8 2.5z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_suo_kai.bb57b4e3.svg";
export { SvgTongyongSuoKai as ReactComponent };